<div class="dialog-container">
  <div mat-dialog-title>
    {{ 'Role.Title' | translate: locale.language }}
  </div>
  <div mat-dialog-content class="dialog-content">
    <div class="search-container">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>
          {{ 'Role.SearchRoles' | translate: locale.language }}
        </mat-label>
        <input matInput [formControl]="searchControl" />
      </mat-form-field>
      @if (isLoading) {
        <mat-progress-bar mode="indeterminate" style="margin-bottom: 1rem"></mat-progress-bar>
      }
      <mat-chip-set class="selected-chip-set">
        @if (selected.selected.length === 0) {
          <mat-chip disabled>
            {{ 'Role.NoneSelected' | translate: locale.language }}
          </mat-chip>
        }
        @for (roleId of selected.selected; track roleId) {
          <mat-chip
            [removable]="true"
            (removed)="onSelectionChange(idToRole.get(roleId))"
            [matTooltip]="idToRole.get(roleId).name">
            {{ idToRole.get(roleId).name }}
            <button matChipRemove [attr.aria-label]="'Remove ' + idToRole.get(roleId).name" [tabIndex]="0">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        }
      </mat-chip-set>
    </div>
    <div class="table-container">
      <mat-table [dataSource]="availableRoles">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="onToggleAll()"
              [indeterminate]="areSomeSelected && !areAllSelected"
              [checked]="areAllSelected"
              [matTooltip]="'Role.SelectAll' | translate: locale.language"
              (keydown.enter)="onToggleAll()"
              [aria-label]="'Select all roles'">
              {{ 'Role.SelectAll' | translate: locale.language }}
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let role">
            <mat-checkbox
              [checked]="isSelected(role)"
              (change)="onSelectionChange(role)"
              (keydown.enter)="onSelectionChange(role)"
              [aria-label]="">
              {{ role.name }}
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let role; columns: displayedColumns"></mat-row>
      </mat-table>
      @if (!totalRoleCount && !isLoading) {
        <mat-hint style="margin: 1rem">
          {{ noRolesText }}
        </mat-hint>
      }
    </div>

    <div class="bottom-container">
      <mat-paginator
        [pageSizeOptions]="[5, 10, 25, 100]"
        [pageSize]="defaultPageSize"
        [length]="totalRoleCount"
        (page)="onPageChange($event)"
        [ngClass]="{ hidden: !totalRoleCount }"></mat-paginator>
    </div>
  </div>

  <div class="right" mat-dialog-actions>
    <button mat-button mat-dialog-close>
      {{ 'Close' | translate: locale.language }}
    </button>
    <button mat-raised-button color="primary" [disabled]="!selected.selected.length" [mat-dialog-close]="selectedRoles">
      {{ addRolesText }}
    </button>
  </div>
</div>
